// token-resolver.ts
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { TokenHelperService } from 'app/global/token-helper.service'; // Your service
import { Observable, of } from 'rxjs';

export const tokenResolver = (
  route: ActivatedRouteSnapshot
): Observable<string> => {
  const tokenHelperService = inject(TokenHelperService);  // Inject TokenHelperService
  const token = route.paramMap.get('token');
  const id = route.paramMap.get('id');
  if (token && id) {
    tokenHelperService.saveSigningPageToken(token, id);   // save token + docId
    tokenHelperService.setCurrentDocId(id);              // set current doc id for this tab/session
  }
  return of(token);  // Return the token or other required data
};
